export default {
  dataIterator: {
    rowsPerPageText: 'Kirjeid leheküljel:',
    rowsPerPageAll: 'Kõik',
    pageText: '{0}-{1} {2}st',
    noResultsText: 'Vastavaid kirjeid ei leitud',
    nextPage: 'Järgmine lehekülg',
    prevPage: 'Eelmine lehekülg'
  },
  dataTable: {
    rowsPerPageText: 'Ridu leheküljel:'
  },
  noDataText: 'Andmed puuduvad',
  carousel: {
    prev: 'Eelmine visuaalne',
    next: 'Järgmine visuaalne'
  }
}
